// utils.js
export const moneyToText = (amount, currency = "TL") => {
    if (!amount || isNaN(amount)) return "";

    const formatMoney = (n) => {
        const ones = ["", "Bir", "İki", "Üç", "Dört", "Beş", "Altı", "Yedi", "Sekiz", "Dokuz"];
        const tens = ["", "On", "Yirmi", "Otuz", "Kırk", "Elli", "Altmış", "Yetmiş", "Seksen", "Doksan"];
        const groups = ["", "Bin", "Milyon", "Milyar", "Trilyon"];

        let numStr = n.toString();
        // Başındaki sıfırları at
        while (numStr.length > 3 && numStr[0] === '0') numStr = numStr.slice(1);
        
        const groupCount = Math.ceil(numStr.length / 3);
        let result = "";

        for (let i = 0; i < groupCount; i++) {
            let groupResult = "";
            const start = Math.max(0, numStr.length - (i + 1) * 3);
            const end = numStr.length - i * 3;
            const chunk = parseInt(numStr.slice(start, end));

            if (chunk > 0) {
                const h = Math.floor(chunk / 100);
                const t = Math.floor((chunk % 100) / 10);
                const o = chunk % 10;

                if (h === 1) groupResult += "Yüz";
                else if (h > 1) groupResult += ones[h] + "Yüz";

                groupResult += tens[t] + ones[o];

                // "Bir Bin" düzeltmesi
                if (i === 1 && chunk === 1) groupResult = "Bin";
                else groupResult += (i > 0 ? groups[i] : "");

                result = groupResult + result;
            }
        }
        return result;
    };

    // Para birimleri tanımlamaları
    const currencyNames = {
        'TL': { major: 'TL', minor: 'Kr' },
        'USD': { major: 'Dolar', minor: 'Cent' },
        'EUR': { major: 'Euro', minor: 'Cent' },
        'GBP': { major: 'Sterlin', minor: 'Peni' }
    };

    // Seçilen para birimini al (Varsayılan TL)
    const selectedCurrency = currencyNames[currency] || currencyNames['TL'];

    const parts = amount.toString().split(".");
    const majorUnit = parseInt(parts[0]);
    const minorUnit = parts[1] ? parseInt(parts[1].padEnd(2, '0').slice(0, 2)) : 0;

    let text = "";
    if (majorUnit > 0) text += formatMoney(majorUnit) + " " + selectedCurrency.major + " ";
    if (minorUnit > 0) text += formatMoney(minorUnit) + " " + selectedCurrency.minor;

    return text.trim();
};